export const policyType = {
  PRIVACY: 'privacy-policy-button',
  COOKIES: 'cookies-policy-button',
  SUBSCRIBER: 'subscriber-agreement-button',
}
